import { render } from "./createConfigDialog.vue?vue&type=template&id=8085d4f4&scoped=true"
import script from "./createConfigDialog.vue?vue&type=script&lang=js"
export * from "./createConfigDialog.vue?vue&type=script&lang=js"

import "./createConfigDialog.vue?vue&type=style&index=0&id=8085d4f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8085d4f4"]])

export default __exports__